import * as React from 'react';
import { Trans } from '@lingui/react';
import { useRouteError } from 'react-router';
import { CustomerFacingError } from 'utils/ui/errors';
import Icon from 'components/Icon';

interface ErrorResponse {
  status: number;
  statusText: string;
  data?: string;
}

const Error: React.FC = () => {
  const error = useRouteError() as CustomerFacingError | ErrorResponse;

  // Check if it's an ErrorResponse (from thrown Response objects)
  const isErrorResponse = error && typeof error === 'object' && 'status' in error;

  // Get error code and message based on error type
  const errorCode = isErrorResponse ? (error as ErrorResponse).status : (error as CustomerFacingError).code;
  const errorMessage = isErrorResponse ? undefined : (error as CustomerFacingError).message;

  return (
    <div className="ex3d-error-container flex h-screen flex-col items-center p-8" data-testid="error-boundary">
      <div className="my-4">
        <Icon className="ex3d-error-logo" />
      </div>
      <div className="ex3d-error-box my-10 w-5/6 bg-gray-100 p-10">
        <div>
          <h3 className="font-bold">Error {errorCode}</h3>
          {errorMessage && (
            <span className="mt-4 text-sm">
              <Trans id={errorMessage} />
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Error;
